import { authApiHandler } from '../services/authApi'
import type { AuthConfig } from '../types/types'
import cookieHandler from '../handlers/cookieHandler'
import tokenHandler from '../handlers/tokenHandler'

export default (config: AuthConfig, cookieHeader?: string) => {
  const cookies = cookieHandler(cookieHeader)
  const token = tokenHandler(config)
  const authApi = authApiHandler(config)

  return async (): Promise<string | null> => {
    const provider = cookies.getProvider()
    const idToken = cookies.getIdToken()
    let zendeskToken = cookies.getZendeskToken()
    const isPunchout = provider === 'dustin_punchout'

    const selectedContactId = cookies.getContactId()

    const isValidZendeskToken = token.isValidZendeskToken(zendeskToken, selectedContactId)

    if (isValidZendeskToken) {
      return zendeskToken
    }

    zendeskToken = await authApi.getZendeskToken(idToken, selectedContactId)

    if (!zendeskToken) {
      return null
    }

    cookies.setZendeskToken(zendeskToken, isPunchout)

    return zendeskToken
  }
}
